<template>
    <div>
        <vue-headful :title="(this.id ? 'Edit' : 'Create') + ' [Marketer Relationship Code] - AMOS365'" />

        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="/admin/settings#codes">Settings</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page" v-if="!code.id">Create Marketer Relationship Code</li>
                <li class="breadcrumb-item active" aria-current="page" v-else>Edit Marketer Relationship Code</li>

            </ol>
        </nav>

        <h4 class="page-header">
            <span v-if="id">Edit: {{ code.marketer_code_label }}</span>
            <span v-else>Create Marketer Relationship Code</span>
        </h4>

        <div class="row">
            <div class="col-lg-8">
                <div class="card mb-3">
                    <div class="card-header">
                        <strong>Details</strong>
                    </div>
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.marketer_code_label, 'text-muted-no': !errors.marketer_code_label}">
                                Code Label: <i class="fa fa-asterisk text-danger fa-sm"></i>
                            </div>
                            <div class="col-md-8 col-12 input-group-sm">
                                <input type="text" v-model="code.marketer_code_label" :class="{'form-control': true, 'is-invalid': errors.marketer_code_label}" placeholder="Enter Marketer Code Label" />

                                <div class="text-danger mt-1" v-if="errors.marketer_code_label">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.marketer_code_label">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.marketer_code_desc, 'text-muted-no': !errors.marketer_code_desc}">
                                Code Description: <i class="fa fa-asterisk text-danger fa-sm"></i>
                            </div>
                            <div class="col-md-8 col-12 input-group-sm">
                                <vue-editor v-model="code.marketer_code_desc"
                                        :editorOptions="editorSettings"
                                        :editor-toolbar="customToolbar"
                                        :class="{'is-invalid': errors.marketer_code_desc}"
                                        placeholder="Enter Marketer Code Description"  />

                                <div class="text-danger mt-1" v-if="errors.marketer_code_desc">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.marketer_code_desc">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_active, 'text-muted-no': !errors.is_active}">
                                Active:
                            </div>
                            <div class="col-md-8 col-12 input-group-sm">
                                <b-form-checkbox v-model="code.is_active" :value="1" :unchecked-value="0" plain>
                                    Inactive Marketer Codes will not be available for selection on Agents/Agencies
                                </b-form-checkbox>

                                <div class="text-danger mt-1" v-if="errors.is_active">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.is_active">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button type="button" class="btn btn-sm btn-success" v-on:click="postCode()" :disabled="saving">
                    <template v-if="saving"><i class="fa fa-spinner fa-spin"></i> Saving</template>
                    <template v-else>Save Marketer Relationship Code</template>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
    import { VueEditor, Quill } from "vue2-editor";

    export default {
        components: {
            VueEditor,
            Quill,
        },

        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                errors: {},
                code: {},

                customToolbar: [
                    [
                        {
                            header: [false, 1, 2, 3, 4, 5, 6]
                        }
                    ],
                    ["bold", "italic", "underline", "strike"], // toggled buttons
                    [
                        {
                            align: ""
                        },
                        {
                            align: "center"
                        },
                        {
                            align: "right"
                        },
                        {
                            align: "justify"
                        }
                    ],
                    ["blockquote"],
                    [
                        {
                            list: "ordered"
                        },
                        {
                            list: "bullet"
                        },
                        {
                            list: "check"
                        }
                    ],
                    [
                        {
                            indent: "-1"
                        },
                        {
                            indent: "+1"
                        }
                    ], // outdent/indent
                    [
                        {
                            color: []
                        },
                        {
                            background: []
                        }
                    ], // dropdown with defaults from theme
                    ["link"],
                ],

                editorSettings: {
                    modules: {
                        toolbar: {
                            container: [
                                [
                                    {
                                        header: [false, 1, 2, 3, 4, 5, 6]
                                    }
                                ],
                                ["bold", "italic", "underline", "strike"], // toggled buttons
                                [
                                    {
                                        align: ""
                                    },
                                    {
                                        align: "center"
                                    },
                                    {
                                        align: "right"
                                    },
                                    {
                                        align: "justify"
                                    }
                                ],
                                ["blockquote"],
                                [
                                    {
                                        list: "ordered"
                                    },
                                    {
                                        list: "bullet"
                                    },
                                    {
                                        list: "check"
                                    }
                                ],
                                [
                                    {
                                        indent: "-1"
                                    },
                                    {
                                        indent: "+1"
                                    }
                                ], // outdent/indent
                                [
                                    {
                                        color: []
                                    },
                                    {
                                        background: []
                                    }
                                ], // dropdown with defaults from theme
                                ["link"], [] // remove formatting button
                            ],
                        },
                    },
                },
            }
        },

        watch: {

        },

        computed: {

        },

        methods: {
            getCode(){
                //Send it
                this.$http.get('/admin/marketer-codes' + (this.id ? '/'+this.id : ''))
                    .then(response => {
                        //Set Data
                        this.code = response.data.code;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            postCode(){
                //Saving
                this.saving = true;

                //Send it
                this.$http.post('/admin/marketer-codes', this.code)
                    .then(response => {
                        //Alert the user
                        this.$toastr.s('Marketer Relationship Code Saved');

                        //Set Back to Settings
                        this.$router.push('/admin/settings#marketer_codes');
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data.errors;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },
        },

        mounted() {
            //Get the Data
            this.getCode();
        }
    }
</script>